import { useState } from 'react';
import { ErrorController } from './interfaces';

export const useErrorController = (): ErrorController => {
    return {};
};
